import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

function CreateNatureBusinessModal({
  createInput, createNatureBusiness, formData,
  getNatureBusinessList, id,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createNatureBusiness(id, formData, () => {
      setModal({ isOpen: false });
      getNatureBusinessList(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput({ key: 'code', label: 'Code:' }, { required: true })}
          </div>
          <div className="col-12 form-group">
            {createInput({ key: 'name', label: 'Name:' }, { required: true })}
          </div>
          <div className="col-12 form-group">
            {createInput({ key: 'description', label: 'Description:' })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              Submit
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">
              Cancel
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateNatureBusinessModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getNatureBusinessList: PropTypes.instanceOf(Function).isRequired,
  createNatureBusiness: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(CreateNatureBusinessModal);
